import React, { useState } from 'react';

const STAR_PATH =
  'M11.2749 5.33668L10.5914 0H8.82326L8.82075 0.00376264L5.88134 5.33542H1.78321L1.39572 7.10512L1.39572 7.10763H1.39823L3.74449 9.21094L1.01662e-08 16H1.34431L1.85344 15.9975L1.85971 15.9925L6.8695 12.3665L10.8146 15.9925L10.8209 15.9975H12.5866L11.7401 9.38904L15.6125 7.11014H15.615L16 5.33668H11.2749Z';

let starUid = 0;

const StarIcon = ({ value = 0, size = 16, ...props }) => {
  const [clipId] = useState(() => `ui-star-clip-${(starUid += 1)}`);
  const v = Number(value) || 0;
  const state = v === 0 ? 'empty' : v % 1 !== 0 ? 'half' : 'full';
  const full = 'var(--ui-sky)';
  const empty = 'var(--ui-star-empty)';

  return (
    <svg width={size} height={size} viewBox='0 0 16 16' fill='none' {...props}>
      {state === 'full' && <path d={STAR_PATH} fill={full} />}
      {state === 'empty' && <path d={STAR_PATH} fill={empty} />}
      {state === 'half' && (
        <React.Fragment>
          <defs>
            <clipPath id={clipId}>
              <rect x='0' y='0' width='8' height='16' />
            </clipPath>
          </defs>
          <path d={STAR_PATH} fill={empty} />
          <path d={STAR_PATH} fill={full} clipPath={`url(#${clipId})`} />
        </React.Fragment>
      )}
    </svg>
  );
};

export default StarIcon;
